import IntroComp from "../components/Intro";

const Intro = () => {
  return <IntroComp fade={true} />;
};

export default Intro;
